import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { Observable } from 'rxjs';

@Injectable()
export class BusinessService {
  constructor(private http: HttpClient) {

  }

  public GetServices(businessId: number) {
    return this.http.get(environment.apiUrl+"api/Service/GetSellersService?sellerId=" +
      businessId);
  }

  // Public profile (name, address); 404 for deleted businesses.
  public getBusinessProfile(businessId: number): Observable<any> {
    return this.http.get(`${environment.apiUrl}api/BusinessProfile/GetBusiness/${businessId}`);
  }

  public getAvailableDays(data): Observable<any> {
    return this.http.get(`${environment.apiUrl}api/Calendar/GetAvailableDays`, { params: this.buildParams(data) });
  }

  public getAvailableHours(data): Observable<any> {
    return this.http.get(`${environment.apiUrl}api/Calendar/GetAvailableHours`, { params: this.buildParams(data) });
  }

  private buildParams(data: Record<string, any>): HttpParams {
    let params = new HttpParams();

    Object.entries(data ?? {}).forEach(([key, value]) => {
      if (value === null || value === undefined || value === '') {
        return;
      }

      if (Array.isArray(value)) {
        value.forEach(item => {
          params = params.append(key, String(item));
        });
        return;
      }

      params = params.set(key, String(value));
    });

    return params;
  }
}
